<template>
  <template v-if="!is_verified">
    <TfRegisterBox
      v-if="isOpenRegister"
      :extraData="extraData"
      @close="handleCloseRegister"
    >
      <chat-form :clientId="clientId" :trip-id="dataTrip" @request-chat="requestChat" :avatarLD='avatarLD'></chat-form>
    </TfRegisterBox>
  </template>
  <button :class="btnClass" @click="chat">
    <slot></slot>
  </button>
<!--  <button :class="btnClass" @click="chat" v-if="isButton === 'true'"><slot></slot></button>
  <template v-else>
    <slot></slot>
  </template>-->
</template>

<script>
import { computed, ref, watchEffect, watch } from 'vue'
import axios from 'axios'
import { TfChatLink, TfRegisterBox } from 'tf-chat'
import { getCookie } from '~/mixins/cookie'
import ChatForm from "~/components/ui/chat/ChatForm"
import { requestChatURL, callbackChatURL } from '~/composables/api/apiDomain'
import { useRoute } from 'vue-router'
import {load} from "recaptcha-v3";
import { useAuthStore } from '~/store/pinia/auth'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'
import { useHeapStore } from '~/store/pinia/heap'

export default {
  name: 'ChatButtonAuth',
  emits: ['chatOpen'],
  props: {
    expertID: { type: Number, default: 0 },
    tripID: { type: Number, default: 0 },
    btnClass: { type: String },
    type: { type: String, default: '' }, // enquiry-3w, enquiry-2w
    isRandom: { type: Boolean, default: false },
    isButton: { type: Boolean, default: true },
    enquiryID: { type: Number, default: 0 },
    avatarLD: { type: Object, default: () => {}}
  },
  components:{
    TfRegisterBox,
    ChatForm
  },
  setup(props, { emit }) {
    const authStore = useAuthStore()
    const route = useRoute()
    const {isMobile} = useDevice()
    const generalStore = useGeneralInfoStore()
    const heapStore = useHeapStore()

    /* chat trigger */
    const dataTrip = ref(null)
    const clientId = ref(null)

    const dataUser = ref(null)

    watchEffect(()=>{
      dataTrip.value = props.tripID
      clientId.value = props.expertID
    })

    const isOpenRegister = ref(false)
    const extraData = ref({})

    const is_verified = getCookie("is_verified=")
    const apiCallBackChat = async() => {
      await axios.post(callbackChatURL, {
        client: clientId.value,
        user_id: "NotLogin",
        random_trip: props.isRandom ? 1 : 0,
        user_type: "TV",
        type_chat: "enquiry-3w",
        // add more params
        currency: getCookie('dj_curr'),
        ip_address: window.client_addr || '',
        country_code: getCookie('country_code'),
        country_name: getCookie('country_name'),
        region_name: getCookie('region_name'),
        city_name: getCookie('city_name'),
      }).then((response) => {
        let result = response.data
        if(result.status && result.status === "SUCCESS") {
          extraData.value = result
        }
      }).catch(err => {
        console.log(err.response)
        throw new Error('Api callBackChat error : ', { cause: err })
      });
    }

    const stateChat = computed(() => generalStore.finishedChat)
    
    const openChatDone = computed(() => generalStore.chatBoxOpenDone)
    
    watch(openChatDone, (obj) => {
      if(Object.keys(obj).length && obj?.openStatus) {
        isOpenRegister.value = !obj?.openStatus
        generalStore.setChatBoxOpenDone({})
      }
    })

    watch(stateChat, ()=>{
      if(stateChat.value === 'finished'){
        // TfChat.init(data.user_chat.token)
        if(dataUser.value != null){
          TfChatLink.push({enquiryId : dataUser.value.enquiry_id, type: 'enquiry-3w', lsId: dataUser.value.ls_id, extraData: dataUser.value})
          TfChatLink.push({enquiryId : dataUser.value.enquiry_id, type: 'enquiry-3w', lsId: dataUser.value.ls_id, extraData: dataUser.value})
          dataUser.value = null
        }
      }
    })

    const requestChat = async(chatData) => {
      dataUser.value = chatData
      await generalStore.setInitChat({
        status: true,
        token: chatData.user_chat.token
      })
      // isOpenRegister.value = false
    }

    const handleCloseRegister = () => {
      if(isMobile) {
        const topElement = document.getElementById("topInfo");
        const headerElement = document.getElementById("header");
        if(topElement) topElement.removeAttribute("style");
        if(headerElement) headerElement.removeAttribute("style");
      }

      isOpenRegister.value = false
    }

    const changeHeapTripPlanUrl = async () => {
      await heapStore.changeChatWindowHeapData({
        trip_plan_url: window.location.href
      })
    }

    const userInfo = computed(() => authStore.getUserInfo)
    const chat = async () => {
      const is_verified = getCookie("is_verified=")

      if (route.name === 'trip-plan-bookable') {
        // TfChatLink call callbackChat api
        TfChatLink.push({enquiryId : props.enquiryID, type: props.type, lsId: props.expertID, extraData: {}})
      } else {
        if(!is_verified) {
          apiCallBackChat()

          if(isMobile) {
            const topElement = document.getElementById("topInfo");
            const headerElement = document.getElementById("header");
            if(topElement) topElement.style.zIndex = '1';
            if(headerElement) headerElement.style.zIndex = '1';
          }

          isOpenRegister.value = true
        } else{
          emit('chatOpen')

          const recaptcha = await load(`${useAppConfig().siteKeyGreCaptcha}`)
          const token = await recaptcha.execute('submit')

          const dataPost = {
            fname: userInfo.value.firstName,
            lname: userInfo.value.lastName,
            email: userInfo.value.email,
            token: userInfo.value.token,
            phone: userInfo.value.phone,
            customer_id: userInfo.value.userId, // TV or TA id
            random_trip: props.isRandom ? 1 : 0,
            trip_id: dataTrip.value,
            client : clientId.value, // LD ID or Expert ID
            // check_newsletter: false,
            currency: getCookie('dj_curr'),
            ip_address: window.client_addr || '',
            country_code: getCookie('country_code'),
            country_name: getCookie('country_name'),
            region_name: getCookie('region_name'),
            city_name: getCookie('city_name'),
            country_gallery: route.name === 'gallery-local-designers' ? route.params.country : undefined,
            'g-recaptcha-response': token
          }
          axios.post(requestChatURL, dataPost).then((response) => {
            let result = response.data
            if(result.status && result.status === "SUCCESS") {
              // console.log(result)
              // TfChat.init(result.user_chat.token)
              switch (props.type) {
                case 'enquiry-3w':
                  TfChatLink.push({enquiryId : result.enquiry_id, type: props.type, lsId: result.ls_id, extraData: result})
                  break
                case 'enquiry-2w':
                  TfChatLink.push({enquiryId: result.enquiry_id, type: props.type})
                  break
              }
            }
          }).catch(err => {
            console.log(err.response)
            throw new Error('Api requestChat error : ', { cause: err })
          })
        }
      }
      if (route.name === 'trip-plan-bookable' || route.name === 'trip-plan') {
        await changeHeapTripPlanUrl();
      }
    }
    /* chat trigger */

    return { chat, isOpenRegister, extraData, is_verified, requestChat, handleCloseRegister, clientId, dataTrip, openChatDone }
  }
}
</script>

<style scoped>

</style>
